<template>
 
  <div class="">
    <div class="q-my-xxs q-py-xl q-px-xl bg-gray-3" v-if="$q.screen.lt.sm">
      <div class="row justify-between">
      <div class="text-h6 text-weight-bolder text-black">Usulan Tema Penelitian</div>
      <div class="text-h6" style="font-size: 12px;">Beranda / <span class="text-secondary">Tema</span></div>
      </div>
    </div>

    <div class="q-my-xxs q-py-xl q-px-xl text-center bg-grey-3" v-if="$q.screen.sm || $q.screen.md || $q.screen.lg || $q.screen.xl">
      <div class="row justify-between">
      <div class="text-h6 text-weight-bolder text-black">Usulan Tema Penelitian</div>
      <div class="text-h6" style="font-size: 12px;">Beranda / <span class="text-secondary">Tema</span></div>
      </div>
    </div>

    <div class="row wrap justify-between items-start content-start">
        <!-- <div class="row"> -->
      <div class="col">
        <!-- .col -->
      </div>
      <div class="col-6 q-pa-lg">
        <form @submit.prevent="addData()">
        <div class="text-h6 text-black" style="padding-bottom: 10px">Asal Organisasi Perangkat Daerah/Instansi</div> 
        <q-input outlined v-model="form.opd" :dense="dense" style="padding-bottom: 20px" />

        <div class="text-h6 text-black" style="padding-bottom: 10px">Usulan Tema Penelitian/Riset/Kajian OPD</div> 
        <q-input outlined v-model="form.tema" :dense="dense" style="padding-bottom: 20px" />

        <div class="text-h6 text-black" style="padding-bottom: 10px">Nama PIC OPD</div> 
        <q-input outlined v-model="form.nama" :dense="dense" style="padding-bottom: 20px" />

        <div class="text-h6 text-black" style="padding-bottom: 10px">Nomor Whatsapp OPD</div> 
        <q-input outlined v-model="form.nomor" :dense="dense" style="padding-bottom: 20px" />

        <q-btn :loadig="btn_add" color="secondary" size="lg" style="width:100%; margin-top:20px" label="Kirim"  @click="addData()" />
        
        </form>
      </div>
      <div class="col">

      <q-dialog v-model="mdl_open">
      <q-card>
        <q-card-section>
          <div class="text-h6">Notifikasi</div>
        </q-card-section>

        <q-card-section class="q-pt-none">
          Berhasil Input Data
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="OK" color="primary" v-close-popup />
        </q-card-actions>
      </q-card>
    </q-dialog>
        <!-- .col -->
      </div>
    <!-- </div>  -->
    </div>

  </div>     
</template>

<script>
export default {
  name: 'tema',
  data() {
         return {
      data_load: false,
      form : {
                    id : '',
                    opd : '',
                    tema : '',
                    nama : '',
                    nomor : '',
                    createAt : '',
                },
      persistent : false,

      list_data: [],
      page_first: 1,
      page_last: 0,
      cari_value: "",
      mdl_open: false,
      btn_add: false,
    };
    },
    methods: {
			getView: function() {
        this.mdl_open = true;
        },

            addData : function() {

            console.log(this.form);
            fetch(this.$store.state.URL_TEMA + "addData", {
                method: "POST",
                headers: {
                    "content-type": "application/json"
                },
                body: JSON.stringify(this.form)
            }).then(res_data => {
                // this.Notify('Sukses Menambah Data', 'primary', 'check_circle_outline');
                console.log(res_data);

                this.getView();
            });
            },


            // ================== PAGINASI ====================
                alertku: function(type, title) {
                this.$swal({
                    type: type,
                    title: title,
                    showConfirmButton: false,
                    timer: 800
                });
                },

                btn_prev : function(){
                        this.cek_load_data = true;
                    if(this.page_first>1){
                        this.page_first--
                    }else{
                        this.page_first = 1;
                    }
                    this.getView();
                },

                btn_next : function(){
                    
                    if(this.page_first >= this.page_last){
                        this.page_first == this.page_last
                    }else{
                        this.page_first++;
                    }
                    this.getView();
                },

                cari_data : function(){
                    this.page_first = 1;
                    this.getView();
                },
                // onFileSelected: function(event) {
                // this.form.file = event.target.files[0];
                // },
                convert_tgl: function(dateString) {
                    var date = new Date(dateString);
                    var getBulan = date.getMonth() + 1; var bulan = '';
                    if (getBulan == '1') {bulan = 'Januari'} 
                    else if(getBulan == '2') {bulan = 'Februari'}
                    else if(getBulan == '3') {bulan = 'Maret'}
                    else if(getBulan == '4') {bulan = 'April'}
                    else if(getBulan == '5') {bulan = 'Mei'}
                    else if(getBulan == '6') {bulan = 'Juni'}
                    else if(getBulan == '7') {bulan = 'Juli'}
                    else if(getBulan == '8') {bulan = 'Agustus'}
                    else if(getBulan == '9') {bulan = 'September'}
                    else if(getBulan == '10') {bulan = 'Oktober'}
                    else if(getBulan == '11') {bulan = 'November'}
                    else if(getBulan == '12') {bulan = 'Desember'}



                    return date.getDate() + " " + bulan + " " + date.getFullYear();
                    // return bulan+ " " + date.getDate() + ". " + date.getFullYear();
                }
		},
		mounted() {
            // this.getView();

		},

}
</script>
